import { useMemo } from "react";
import useMcubeEngageConfiguration from "V2.0/HomePages/Integrations/Communications/Whatsapp/MCubeEngage/useMCubeEngageConfiguration";
import { useWhatsappConfiguration } from "V2.0/HomePages/Integrations/Whatsapp/models/useWhatsappConfiguration";

export default useWhatsapp;

export const WhatsappProvider = {
  META: "meta",
  MCUBE_ENGAGE: "mcubeEngage",
};

function getMetaWhatsappPhoneNumbers(whatsappConfiguration) {
  if (!whatsappConfiguration.isConfigured) return [];
  return whatsappConfiguration.data.phoneNumberIds;
}

function getMcubeEnagePhoneNumbers(mcubeEngageConfiguration) {
  if (!mcubeEngageConfiguration.isConfigured) return [];
  return mcubeEngageConfiguration.mcubeEngageConfiguration.phoneNumbers;
}

function useWhatsapp(workspaceId) {
  const { whatsappConfiguration } = useWhatsappConfiguration(workspaceId);
  const mcubeEngageConfiguration = useMcubeEngageConfiguration(workspaceId);

  const { phoneNumbers, phoneNumbersProviderMap } = useMemo(() => {
    if (whatsappConfiguration.isLoading || mcubeEngageConfiguration.isLoading) {
      return { phoneNumbers: [], phoneNumbersProviderMap: {} };
    }

    const metaWhatsappPhoneNumbers = getMetaWhatsappPhoneNumbers(
      whatsappConfiguration,
    );
    const mcubeEngagePhoneNumbers = getMcubeEnagePhoneNumbers(
      mcubeEngageConfiguration,
    );

    const phoneNumberProviderRegistry = {
      [WhatsappProvider.META]: metaWhatsappPhoneNumbers,
      [WhatsappProvider.MCUBE_ENGAGE]: mcubeEngagePhoneNumbers,
    };

    const phoneNumbersProviderMap = Object.values(WhatsappProvider).reduce(
      (acc, provider) => {
        const providerNumbers = phoneNumberProviderRegistry[provider];

        return providerNumbers.reduce((acc, number) => {
          return {
            ...acc,
            [number]: provider,
          };
        }, acc);
      },
      {},
    );

    return {
      phoneNumbers: [...metaWhatsappPhoneNumbers, ...mcubeEngagePhoneNumbers],
      phoneNumbersProviderMap,
    };
  }, [
    whatsappConfiguration,
    mcubeEngageConfiguration,
  ]);

  const getActiveWhatsappProvider = (phoneNumberId) => {
    return phoneNumbersProviderMap[phoneNumberId];
  };

  return {
    whatsappConfiguration,
    mcubeEngageConfiguration,
    phoneNumbers,
    phoneNumbersProviderMap,
    getActiveWhatsappProvider,
  };
}
